export default __webpack_public_path__ + "static/media/IconDesc_Concrete.256.c15dc225.png";